import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import cn from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import {OPEN_DRAW_CONTROL_POPUP} from '../../constants/action-types'
import {drawControlPopupSelector} from '../../selectors'

import styles from './DrawControl.module.scss'

export default function ControlTooltip(props) {
    const {popupName, icon, title} = props
    const drawControlPopup = useSelector(drawControlPopupSelector)
    const dispatch = useDispatch()

    const showPopup = () => {
        dispatch({
            type: OPEN_DRAW_CONTROL_POPUP,
            payload: popupName,
        })
    }

    return (
        <div className="panel-control__item">
            <Tooltip title={title}>
                <div>
                    <IconButton
                        onClick={showPopup}
                        className={cn(styles.CTIconButton, {
                            [styles.active]: drawControlPopup === popupName,
                        })}
                    >
                        {icon}
                    </IconButton>
                </div>
            </Tooltip>
        </div>
    )
}
